import { render, staticRenderFns } from "./ipHistory.vue?vue&type=template&id=c677f060&scoped=true&"
import script from "./ipHistory.vue?vue&type=script&lang=js&"
export * from "./ipHistory.vue?vue&type=script&lang=js&"
import style0 from "./ipHistory.vue?vue&type=style&index=0&id=c677f060&lang=scss&scoped=true&"
import style1 from "./ipHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c677f060",
  null
  
)

export default component.exports